import { useLingui } from "@lingui/react/macro";

import type { ProjectType } from "../types";

/**
 * What the dialog and the window put in their title bar.
 *
 * A hook rather than a function taking `t`: a lingui `t` handed to another
 * function renders empty strings, without saying so.
 */
export function useShellTitle(
  projectId: number | null,
  type: ProjectType,
): string {
  const { t } = useLingui();

  if ("subscription" === type) {
    return null === projectId ? t`New subscription` : t`Subscription`;
  }

  return null === projectId ? t`New intervention` : t`Intervention`;
}
